import { Component, OnInit } from '@angular/core';
import { VaniToast, VaniToasterService } from 'src/app/services/vani-toaster.service';

@Component({
  selector: 'app-toast-container',
  templateUrl: './toast-container.component.html',
  styleUrls: ['./toast-container.component.css']
})
export class ToastContainerComponent implements OnInit {

  toasts: VaniToast[] = [];

  constructor(private toastService: VaniToasterService) { }

  ngOnInit() {
    this.toastService.toasts$.subscribe((toasts) => {
      this.toasts = toasts;
    });
  }

  remove(id: number | undefined) {
    if (id) this.toastService.removeToast(id);
  }

}
